import { API } from '../config';

const BASE_VALUATION = `${API.BASE_DEV_HOST}/api/valuation`;
const BASE_VALUATION_ALLOCATION = `${API.BASE_DEV_HOST}/api/valuation-allocation`;
const BASE_VALUATIONS = `${API.BASE_DEV_HOST}/api/valuations`;

export const createEffectiveTaxRate = `${BASE_VALUATIONS}/effective-tax-rate/create`;
export const getEffectiveTaxRate = (companyMeasurementDate: string) =>
  `${BASE_VALUATIONS}/effective-tax-rate/${companyMeasurementDate}`;

export const getFirmCompGroups = (firmId: string) => `${BASE_VALUATION}/comp-group/firm/${firmId}`;
export const getGPC = (
  ticker: string,
  md: number,
  currencySymbol: string,
  calendarYears: string,
  customDate?: string
) => {
  let queryString = `${BASE_VALUATION}/gpc/${md}?identifier=${ticker}&currency=${currencySymbol}&calendar_years=${calendarYears}`;
  if (customDate) {
    queryString += `&custom_date=${customDate}`;
  }
  return queryString;
};
export const getPublicCompList = (
  md: string,
  currencySymbol: string,
  tickers: string,
  calendarYears: string,
  customDate: string,
  searchForIndexes = false
) => {
  let url = `${BASE_VALUATION}/pc-list/${md}?identifiers=${tickers}&currency=${currencySymbol}&search_for_indexes=${searchForIndexes}`;
  if (calendarYears) url += `&calendar_years=${calendarYears}`;
  if (customDate) url += `&custom_date=${customDate}`;
  return url;
};
export const getTickerByKeyword = (keyword: string) => `${BASE_VALUATION}/ticker-search?keywords=${keyword}`;
export const getTransaction = (transactionId: string) =>
  `${BASE_VALUATION}/get-transaction-information/${transactionId}/`;
export const getValuationApproaches = (measurementDateId: string, allocationVersionId: string) =>
  `${BASE_VALUATION}/approaches/${measurementDateId}/${allocationVersionId}`;
export const updateEffectiveTaxRate = (id: string) => `${BASE_VALUATIONS}/effective-tax-rate/${id}/update`;
export const updateValuation = (valuationId: string) => `${BASE_VALUATION}/${valuationId}`;
export const valuationByAllocationId = (allocationId: string) => `${BASE_VALUATION_ALLOCATION}/${allocationId}`;
export const createNewVersion = (allocationId: string) => `${BASE_VALUATION_ALLOCATION}/${allocationId}/new-version`;
export const setReadyForAudit = (valuationId: string) => `${BASE_VALUATION}/${valuationId}/ready-for-audit`;
